  import React, { Component } from "react";
  import Chapterscard from "./Chapterscard";
  
  
  export default class Moresholk extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loading: true,
        data: [],
        filterText: "", 
      };
      this.getallchapters = this.getallchapters.bind(this);
      this.handleFilterChange = this.handleFilterChange.bind(this);
    }
  
    componentDidMount() {
      this.getallchapters();
    }
  
    getallchapters() {
      fetch("https://vedicscriptures.github.io/chapters")
        .then((res) => res.json())
        .then(
          (result) => {
            console.log(result);
            this.setState({
              loading: false,
              data: result,
            });
          },
          (error) => {
            this.setState({
              loading: false,
            });
          }
        )
        .catch((err) => {
          console.log(err);
          this.getallchapters();
        });
    }
  
    handleFilterChange(event) {
      this.setState({
        filterText: event.target.value, // Update filterText state based on user input
      });
    }
  
    render() {
      const { data, loading, filterText } = this.state; // Destructure state
  
      // Filter data based on filterText
      const filteredData = data.filter((item) => {
        // Check if item.chapter_title exists and convert it to lowercase for comparison
        const title = item.chapter_title ? item.chapter_title.toLowerCase() : "";
        return title.includes(filterText.toLowerCase());
      });
  
      return (
        <div className="row mt-5">
          <div className="col-md-2"></div>
          <div className="col-md-8">
            <h3 className="display-4">Chapters / अध्याय </h3>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Search chapters..."
              value={filterText} // Bind input value to filterText state
              onChange={this.handleFilterChange} // Call handleFilterChange on input change
            />
            <hr />
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-warning" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div>
                {filteredData.map((item, index) => (
                  <Chapterscard key={item.chapter_number} data={item} />
                ))}
              </div>
            )}
          </div>
        </div>
      );
    }
  }
  